import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';

export const globalSearch = createAsyncThunk(
    'search/globalSearch',
    async (params, { getState, rejectWithValue }) => {
        try {
            const { loginToken, loginTokenCoUser } = getState();
            const authToken = loginToken?.response?.token || loginTokenCoUser?.response?.token;
            const business_id = loginToken?.response?.user?.business_id || loginTokenCoUser?.response?.user?.business_id;
            const queryParams = new URLSearchParams();
            if (params.query) queryParams.append('query', params.query);
            if (params.kbTags) queryParams.append('kbTags', params.kbTags);
            if (params.ticketTags) queryParams.append('ticketTags', params.ticketTags);
            if (params.chatTags) queryParams.append('chatTags', params.chatTags);
            if (params.status) {
                const kbStatuses = ['published', 'draft', 'pendingReview', 'archived'];
                if (kbStatuses.includes(params.status)) {
                    queryParams.append('kbStatus', params.status);
                } else {
                    queryParams.append('ticketStatus', params.status);
                }
            }
            if (params.type) queryParams.append('type', params.type);
            if (params.timeframe) queryParams.append('timeframe', params.timeframe);
            if (params.timeframe === 'custom') {
                if (params.startDate) queryParams.append('startDate', params.startDate);
                if (params.endDate) queryParams.append('endDate', params.endDate);
            }
            if (params.assignee) queryParams.append('assignee', params.assignee);
            if (params.page) queryParams.append('page', params.page);
            if (params.sortBy) queryParams.append('sortBy', params.sortBy);
            if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);

            const response = await axios.get(
                `${ROOT_URL}/search/${business_id}?${queryParams.toString()}`,
                {
                    headers: {
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const initialState = {
    loading: false,
    error: null,
    success: false,
    results: null,
};

const globalSearchSlice = createSlice({
    name: 'globalSearch',
    initialState,
    reducers: {
        resetSearchState: (state) => {
            state.loading = false;
            state.error = null;
            state.success = false;
            state.results = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(globalSearch.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(globalSearch.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.results = action.payload;
            })
            .addCase(globalSearch.rejected, (state, action) => {

                if (action.meta?.aborted) return;
                state.loading = false;
                state.error = action.payload;
                state.success = false;
            });
    }
});

export const { resetSearchState } = globalSearchSlice.actions;
export default globalSearchSlice.reducer;
